import {selector} from "./selector";

const changeVisibilityOldPassword = function (e) {
    e.preventDefault();
    changePasswordVisibility(selector.oldPasswordVisibility, selector.oldPassword)
}

const changeVisibilityNewPassword = function (e) {
    e.preventDefault();
    changePasswordVisibility(selector.newPasswordVisibility, selector.newPassword)
}

const changeVisibilityNewPasswordConfirm = function (e) {
    e.preventDefault();
    changePasswordVisibility(selector.newPasswordConfirmVisibility, selector.newPasswordConfirm)
}

const changePasswordVisibility = function (iconParent, passwordInput) {
    const icon = $(iconParent).find('i')[0];
    passwordInput = $(passwordInput)[0];
    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        icon.classList.remove('fa-eye-slash');
        icon.classList.add('fa-eye');
    } else {
        passwordInput.type = 'password';
        icon.classList.remove('fa-eye');
        icon.classList.add('fa-eye-slash');
    }
}

export {changeVisibilityOldPassword, changeVisibilityNewPassword, changeVisibilityNewPasswordConfirm};